import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Dinero, { Currency } from 'dinero.js';

import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { store } from '@Managers/Redux/Store';

const FALLBACK_LANGUAGE: string = ConfigLoader?.language;
const SUPPORTED_LANGUAGES: string[] = ['pl', 'en', 'sk', 'cs', 'ro', 'hr'];

const PLACEHOLDER_TRANSLATIONS = {
    en: { translation: { SHOW_NEXT_TIME: 'test' } },
    pl: { translation: { SHOW_NEXT_TIME: 'test' } },
    sk: {},
    cz: {},
    ro: {},
    hr: {}
};

i18n.use(initReactI18next).init({
    resources: PLACEHOLDER_TRANSLATIONS,
    lng: FALLBACK_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    keySeparator: false,
    interpolation: {
        escapeValue: false,
        format: (value, rawFormat = '', lng) => {
            const [format, ...additionalValues] = rawFormat.split(',').map((v) => v.trim());
            switch (format) {
                case 'uppercase':
                    return value.toUpperCase();
                case 'price':
                    const code = store.getState().http.authenticateResponseData?.account.currency?.code as Currency;
                    const amount = Math.round(value);
                    return Dinero({ amount, currency: code }).toFormat();
            }
        }
    },
    load: 'currentOnly'
});

export default i18n;
